<ngb-pagination
    *ngIf="collectionSize > pageSize"
    [collectionSize]="collectionSize"
    [(page)]="page"
    [pageSize]="pageSize"
    [maxSize]="maxSize"
    [rotate]="rotate"
    [ellipses]="ellipses"
    [boundaryLinks]="boundaryLinks"
    [directionLinks]="directionLinks"
    (pageChange)="onPageChange($event)"
    [size]="style"
></ngb-pagination>
